import React from 'react';
import styles from '../../../../styles/DashboardV2.module.css';

interface EmptyStateProps {
    icon?: string;
    message: string;
    action?: { label: string; onClick: () => void };
}

const EmptyState: React.FC<EmptyStateProps> = ({ icon = '📭', message, action }) => (
    <div className={styles.emptyState}>
        <span className={styles.emptyStateIcon}>{icon}</span>
        <p className={styles.emptyStateText}>{message}</p>
        {action && (
            <button className={styles.emptyStateAction} onClick={action.onClick}>
                {action.label}
            </button>
        )}
    </div>
);

export default EmptyState;
